import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "components/shared/toast/toast";
import { TASK } from "services/apiEndpoints";
import { privateDelete, privateGet, privatePut } from "services/privateRequest";
import { makeQueryString } from "utils/utils";

const initialState = {
  tasks: [],
  status: "idle", // 'idle' | 'loading' | 'error'
  pageNumber: 1,
  pageSize: 10,
  totalCount: 0,
  updateStatus: "idle", // new: 'idle' | 'loading' | 'error'
  filters: {
    selectedTeam: { label: "", value: "" },
  }
};

export const getTaskData = createAsyncThunk(
  "task/getTaskData",
  async (params) => {
    const res = await privateGet(TASK);

    return {
      data: res?.data?.data?.tasks || [],
      totalCount: res?.data?.length || 0,
    };
  }
);

export const getTaskList = createAsyncThunk(
  "task/getTaskList",
  async (payload, { rejectWithValue, dispatch, signal }) => {
    try {
      const queryString = makeQueryString(TASK, payload);

      const { data } = await privateGet(queryString, { signal });

      dispatch(setPageNumber(payload.pageNumber));
      dispatch(setPageSize(payload.limit));

      return {
        tasks: data?.data?.tasks || [],
        totalCount: data?.data?.totalResponses || 0,
      };
    } catch (error) {
      rejectWithValue(error);
      return error;
    }
  }
);

// export const getTaskListById = createAsyncThunk(
//   "task/getTaskList/id",
//   async (payload, { rejectWithValue, dispatch, signal }) => {
//     try{
//       const queryString = makeQueryString(TASK, payload);

//       const { data } = awaitprivateGet(queryString, { signal });

//       dispatch(setPageNumber(payload.pageNumber));
//       dispatch(setPageSize(payload.limit));

//       return {
//         tasks: data?.data?.tasks || [],
//         totalCount: data?.data?.totalResponses || 0,
//       };
//     } catch (error) {
//       rejectWithValue(error);
//       return error;
//       }
//     }
// );

export const getTaskStatus = createAsyncThunk(
  "task/getTaskStatus",
  async ({ taskId, action, rejectionReason }, { rejectWithValue, dispatch, getState }) => {
    try {
      const body = { action };

      if (action === "reject") {
        if (!rejectionReason?.trim()) {
          return rejectWithValue("Rejection reason is required");
        }
        body.rejectionReason = rejectionReason;
      }

      const res = await privatePut(
        "/api/task/admin/action",
        "",
        body,
        { params: { _id: taskId } }
      );

      const { pageNumber = 1, pageSize = 10 } = getState().task || {};
      dispatch(getTaskList({ pageNumber, limit: pageSize }));

      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error.message || "Request failed"
      );
    }
  }
);


export const deleteTask = createAsyncThunk(
  "task/deleteTask",
  async (id, { dispatch }) => {
    await privateDelete(TASK, id);
    dispatch(getTaskData());
    toast.success("Task deleted successfully");
  }
);

const taskSlice = createSlice({
  name: "task",
  initialState,
  reducers: {
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.pageNumber = 1;
    },
    setSelectedTeamFilter: (state, action) => {
      if (!action.payload) {
          state.filters.selectedTeam = { label: "", value: "" };
      }
      else { state.filters.selectedTeam = action.payload; }
  },
  },
  extraReducers: {
    [getTaskList.pending]: (state) => {
      state.status = "loading";
    },
    [getTaskList.rejected]: (state) => {
      state.status = "error";
      state.tasks = [];
      state.totalCount = 0;
    },
    [getTaskList.fulfilled]: (state, action) => {
      state.status = "idle";
      state.tasks = action.payload.tasks;
      state.totalCount = action.payload.totalCount;
    },

    [getTaskStatus.pending]: (state) => {
      state.updateStatus = "loading";
    },
    [getTaskStatus.rejected]: (state, action) => {
      state.updateStatus = "error";
      toast.error(action.payload?.message || "Failed to update task status");
    },
    [getTaskStatus.fulfilled]: (state, action) => {
      state.updateStatus = "idle";
      toast.success(action.payload?.message || "Task status updated successfully");
    },
  },
});

export default taskSlice.reducer;
export const { setPageNumber, setPageSize , setSelectedTeamFilter } = taskSlice.actions;
